import { Model } from '@vuex-orm/core';
import { uuidv4 } from '@/utils/helpers';
import {
  Company,
  ProductProductType,
  ProductType,
} from './models';

export class Product extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'products';

  static fields() {
    return {
      id: this.attr(() => uuidv4()),
      name: this.attr(null),
      density: this.attr(null),
      is_hidden: this.attr(null),
      is_service: this.attr(null),
      supplier_company_id: this.attr(null),
      supplier_company: this.belongsTo(Company, 'supplier_company_id'),
      types: this.belongsToMany(ProductType, ProductProductType, 'product_id', 'product_type_id'),
      updated_at: this.attr(null),
      created_at: this.attr(null),
    };
  }
}

export default Product;
